module.exports = __webpack_public_path__ + "static/media/page103_03.829cb46c.jpg";